function Loading() {
    return (
        <img src={process.env.PUBLIC_URL + "/img/loading.svg"}/>
    );
}

export default Loading;